var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize",
        },
      ],
      staticClass: "pa-0 ma-0",
      attrs: { fluid: "" },
    },
    [
      _c("v-data-table", {
        attrs: {
          dense: "",
          "show-select": _vm.isJbg,
          "items-per-page": _vm.pageSize,
          expanded: _vm.expanded,
          headers: _vm.headers,
          height: _vm.tableSize,
          items: _vm.documents,
          loading: _vm.loading,
          "item-key": "id",
          "loading-text": "Loading, please wait...",
          "no-data-text": "No files to show",
          "no-results-text": "No results found",
          "hide-default-footer": "",
          "fixed-header": "",
        },
        on: {
          "update:expanded": function ($event) {
            _vm.expanded = $event
          },
          "update:items": function ($event) {
            _vm.documents = $event
          },
          "click:row": _vm.getDocDetails,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "top",
              fn: function () {
                return [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: { cursor: "default" },
                      attrs: { flat: "", color: "toolbar", height: "75" },
                    },
                    [
                      _c(
                        "span",
                        [
                          _c("v-toolbar-title", [
                            _vm._v(_vm._s(_vm.sectionTitle)),
                          ]),
                        ],
                        1
                      ),
                      _c("v-divider", {
                        staticClass: "mx-4",
                        attrs: { inset: "", vertical: "" },
                      }),
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "3" } },
                        [
                          _c("PartySelect", {
                            attrs: {
                              selectedParties: _vm.selectedParties,
                              includeOwnerRetailerAdGroups: true,
                            },
                            on: {
                              "update:selectedParties": function ($event) {
                                _vm.selectedParties = $event
                              },
                              "update:selected-parties": function ($event) {
                                _vm.selectedParties = $event
                              },
                              remove: _vm.removeParty,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("DocumentTags", {
                        attrs: { filteredIds: _vm.excludedSubcategories },
                        on: { cancelLoad: () => (_vm.loading = false) },
                        model: {
                          value: _vm.tags,
                          callback: function ($$v) {
                            _vm.tags = $$v
                          },
                          expression: "tags",
                        },
                      }),
                      _vm.isJbg
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-center",
                              attrs: { cols: "2" },
                            },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "flex-grow-1 text-none px-2",
                                                    attrs: {
                                                      outlined: "",
                                                      height: "40",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [_vm._v("mdi-calendar-range")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-truncate",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateRangeLabel ||
                                                          "Created date"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1388664997
                                  ),
                                  model: {
                                    value: _vm.dateMenu,
                                    callback: function ($$v) {
                                      _vm.dateMenu = $$v
                                    },
                                    expression: "dateMenu",
                                  },
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        range: "",
                                        "no-title": "",
                                        scrollable: "",
                                      },
                                      model: {
                                        value: _vm.dateRange,
                                        callback: function ($$v) {
                                          _vm.dateRange = $$v
                                        },
                                        expression: "dateRange",
                                      },
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.dateRange = []
                                            },
                                          },
                                        },
                                        [_vm._v("Clear")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.dateMenu = false
                                            },
                                          },
                                        },
                                        [_vm._v("Done")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.dateRange.length > 0
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-1",
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        title: "Clear date range",
                                      },
                                      on: { click: _vm.clearDateRange },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-close")])],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "flex-grow-1 rounded-r-0",
                            attrs: {
                              label: "Filter",
                              placeholder:
                                "Filter page by file name or description",
                              "prepend-inner-icon": "mdi-text-search-variant",
                              "hide-details": "auto",
                              "background-color": "input",
                              dense: "",
                              outlined: "",
                              clearable: "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.resetAndSearch()
                              },
                            },
                            model: {
                              value: _vm.filterText,
                              callback: function ($$v) {
                                _vm.filterText = $$v
                              },
                              expression: "filterText",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "rounded-l-0",
                              attrs: {
                                color: "primary",
                                depressed: "",
                                height: "40",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetAndSearch()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-magnify")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.isJbg
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-4",
                              attrs: {
                                color: "primary",
                                depressed: "",
                                height: "40",
                                disabled: _vm.selected.length === 0,
                                loading: _vm.downloadingBulk,
                              },
                              on: { click: _vm.downloadBulkSelected },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-folder-download-outline"),
                              ]),
                              _vm._v(
                                " Download selected (" +
                                  _vm._s(_vm.selected.length) +
                                  ") "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "expanded-item",
              fn: function ({ headers, item }) {
                return [
                  _c(
                    "td",
                    { attrs: { colspan: headers.length } },
                    [
                      _vm._l(item.metadata, function (meta, metaKey) {
                        return _c(
                          "span",
                          { key: metaKey },
                          [
                            _c("strong", {
                              domProps: { textContent: _vm._s(metaKey) },
                            }),
                            _vm._v(" " + _vm._s(meta) + " "),
                            _c("v-divider", {
                              staticClass: "ml-2 mr-2",
                              attrs: { vertical: "" },
                            }),
                          ],
                          1
                        )
                      }),
                      !item.metadata && item.parties.length === 0
                        ? [
                            _vm._v(
                              " There is no metadata attached to this document "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
            },
            {
              key: `item.name`,
              fn: function ({ item }) {
                return [
                  _vm.isAdminUser
                    ? _c("span", { class: { "doc-name": _vm.isJbg } }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ])
                    : _c(
                        "v-tooltip",
                        {
                          attrs: { top: "", "open-delay": "400" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "span",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            class: { "doc-name": _vm.isJbg },
                                            staticStyle: { cursor: "pointer" },
                                          },
                                          "span",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" " + _vm._s(item.name) + " ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_c("span", [_vm._v("Click to Download")])]
                      ),
                ]
              },
            },
            {
              key: `item.actions`,
              fn: function ({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "text-no-wrap" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.downloadFile(item.id)
                            },
                          },
                        },
                        [_vm._v(" mdi-file-download-outline ")]
                      ),
                      _vm.isAdminUser
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.openDeleteDialog(item)
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("mdi-trash-can-outline"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: `item.tags.category`,
              fn: function ({ item }) {
                return [
                  item.tags.category
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getCategoryName(item.tags.category)) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]
              },
            },
            {
              key: `item.tags.subcategory`,
              fn: function ({ item }) {
                return [
                  item.tags.subcategory !== "" && item.tags.subcategory !== null
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getSubcategoryName(
                                item.tags.category,
                                item.tags.subcategory
                              ) || "-"
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]
              },
            },
            {
              key: `item.tags.subtype`,
              fn: function ({ item }) {
                return [
                  item.tags.subtype
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getSubtypeName(
                                item.tags.category,
                                item.tags.subcategory,
                                item.tags.subtype
                              )
                            ) +
                            " "
                        ),
                      ])
                    : _c("span", [_vm._v("-")]),
                ]
              },
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c("v-divider"),
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "", color: "toolbar" } },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticStyle: { "max-width": "150px" },
                          attrs: { cols: "2", sm: "3" },
                        },
                        [
                          _c("v-select", {
                            staticClass: "mt-8",
                            attrs: {
                              dense: "",
                              items: _vm.pageSizes,
                              label: "Items Per Page",
                              "menu-props": {
                                top: true,
                                offsetY: true,
                                maxHeight: 500,
                              },
                            },
                            model: {
                              value: _vm.pageSize,
                              callback: function ($$v) {
                                _vm.pageSize = $$v
                              },
                              expression: "pageSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disablePrevious,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.previous()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                        1
                      ),
                      _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disableNext,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.next()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showDeleteDialog
                    ? _c(
                        "v-dialog",
                        {
                          attrs: { width: "450" },
                          on: {
                            "click:outside": function ($event) {
                              _vm.showDeleteDialog = false
                              _vm.selectedDocument = {}
                            },
                          },
                          model: {
                            value: _vm.showDeleteDialog,
                            callback: function ($$v) {
                              _vm.showDeleteDialog = $$v
                            },
                            expression: "showDeleteDialog",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [_vm._v("Delete Document")]),
                              _c("v-card-text", [
                                _vm._v(
                                  ' Delete "' +
                                    _vm._s(_vm.selectedDocument.name) +
                                    '"? '
                                ),
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      class: _vm.body,
                                      attrs: { text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showDeleteDialog = false
                                        },
                                      },
                                    },
                                    [_vm._v("Close")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "red white--text",
                                      class: _vm.body,
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteDoc(
                                            _vm.selectedDocument
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }